<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="common-padding">
  <app-bpg-events></app-bpg-events>
  <div id='included_page' class="form-outer-div">
    <div class="form-group">
      <span>
        <input id="date" name="date" class="date-control"  bsDatepicker [ngModel]="date" [bsConfig]="{ dateInputFormat: 'MMMM YYYY' }" (onShown)="onOpenCalendar($event)" (ngModelChange)="onDateChange($event)">
        </span>
    </div>

    <div class="form-group">
      <ng-select placeholder ="--Select Site--" class="custom" [items]="siteList" bindLabel="siteName" [(ngModel)]="selectedSite" (change)="siteChange($event)"></ng-select> 
    </div>

    <div class="form-group">

      <div>
          <ng-select placeholder ="--Select BPG--"  class="custom" [items]="bpgList" bindLabel ="bpgName" [(ngModel)]="selectedBpg" (change)="bpgChange($event)" ></ng-select>    
    </div>
    </div>
    <div class="form-group">
        <input type="text" class="form-control keywords" id="search" placeholder="Search by event name" [(ngModel)]="searchKey">
      </div>
      <div id="searchSecn" style="display: inline-flex;">
        <button type="button" class="btn btn-danger" (click)="searchEvents()">Search</button>
        <span class="download-icon mt-1 pt-2 pl-3 color" [ngClass]="{'disabled': !(this.eventList!=null && this.eventList!=undefined && this.eventList.length>0)}" (click)="downloadEvents()"><mat-icon class="download-style" matTooltip="download">download</mat-icon></span>
        <span class="download-icon mt-1 pt-2 pl-4 color" [ngClass]="{'disabled': !(this.eventList!=null && this.eventList!=undefined && this.eventList.length>0)}" (click)="printEvents()"><mat-icon class="download-style" matTooltip="print">print</mat-icon></span>
      </div>
  </div> 
<div>
<button class= "previousButton small-btn-style-pvs"
mwlCalendarPreviousView
[view]="view"
[(viewDate)]="viewDate"
(viewDateChange)="activeDayIsOpen = false;setPreviousMonth()"><i class="fa fa-angle-left arrow-icon" aria-hidden="true"></i>{{ previousMonth | date:'MMM yyyy'}}</button>
<button class="nextButton small-btn-style-nxt"
mwlCalendarNextView
[view]="view"
[(viewDate)]="viewDate"
(viewDateChange)="activeDayIsOpen = false;setNextMonth()">{{ nextMonth | date:'MMM yyyy' }}<i class="fa fa-angle-right arrow-icon" aria-hidden="true"></i></button>
</div>
<br><br><br>

<ng-template #customCellTemplate let-day="day" let-locale="locale">
  <div class="cal-cell-top">
  
    <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
    <div *ngFor="let data of day.events">
      <div  class = "eventTitle" *ngIf="day.events!=0" >{{data.title}}</div>
      
</div>
      
  </div>

</ng-template>

<div class="table-responsive">
<div [ngSwitch]="view" class="col-sm-12 col-md-12 col-xl-12" >
  <mwl-calendar-month-view
    *ngSwitchCase="CalendarView.Month"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [cellTemplate]="customCellTemplate"
    [activeDayIsOpen]="activeDayIsOpen"
    (dayClicked)="dayClicked($event.day)"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
   >
  </mwl-calendar-month-view>
</div></div>
</div>
<br><br><br>
 <!-- for printing events-->
 <div id="printEvents" [hidden]="true">
  <div class="mt-3 mb-2">
      <div class="text-center"
          *ngIf="this.siteNamePrint=='Select All' && this.bpgNamePrint=='Select All'">
          <h2>Events Report</h2>
      </div>
      <div class="text-center" *ngIf="this.siteNamePrint!=='Select All' && this.bpgNamePrint!=='Select All'">
          <h2>Events Report for {{siteNamePrint}} - {{bpgNamePrint}} </h2>
      </div>
      <div class="text-center" *ngIf="this.siteNamePrint!='Select All' && this.bpgNamePrint=='Select All'">
          <h2>Events Report for All {{siteNamePrint}}</h2>
      </div>
      <div class="text-center" *ngIf="this.siteNamePrint=='Select All' && this.bpgNamePrint!='Select All'">
        <h2>Events Report for All {{bpgNamePrint}}</h2>
    </div>
  </div>
  <div *ngFor="let events of eventList">
      <div class="m-4 event-list event-list-outerdiv">
          <div class="date_span">
              <span class="date-style">{{events.eventDay}}</span><br>
              <span class="month-style">{{events.eventMonth}}</span>
          </div>
          <div class="events_info">
              <span class="filteredBpg">{{events.siteName}}</span><span
                  class="colon-padding filteredBpg">-</span><span class="filteredBpg">{{events.bpgName}}</span><span
                  class="colon-padding filteredBpg"> -
              </span><span class="event-name-span">{{events.eventName}}</span>
              <div class="event-time-loc">
                  <span class="common-line-height">{{events.startTime}}</span> to
                  <span>{{events.endTime}}</span><span> {{events.timeZone}} </span><br>
                  <div class="view-details-align">
                      <span class="common-line-height">{{events.description}}<span
                              class="common-line-height"></span></span>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>





